import FurnishingCopyEventForm from "./furnishing-copy-event-form";

export default FurnishingCopyEventForm;